// extracted by mini-css-extract-plugin
export default {"footer-wrapper":"Footer_footer-wrapper__GbXRc","texts":"Footer_texts__xN08j","social-media":"Footer_social-media__XnDD+","media-buttons":"Footer_media-buttons__JC3ky"};